module.exports = __webpack_public_path__ + "static/img/aboutUs@2x.4c88937f.png";